export const EXPERIMENT_ESTHER_ADS = "e2";
export const EXPERIMENT_ESTHER_ADS_ENABLED = true;
export const EXPERIMENT_ESTHER_ADS_DISABLED = false;

export const EXPERIMENT_CHECKOUT_PRESETS = "e3";
export const EXPERIMENT_CHECKOUT_PRESETS_ON = 1;
export const EXPERIMENT_CHECKOUT_PRESETS_OFF = 0;